import { Link } from "react-router-dom";

export const Navbar = (props) => {
  return (
    <>
      <nav
        className={`navbar navbar-expand-lg navbar-${props.mode} bg-${props.mode}`}
      >
        <div className="container-fluid">
          <a className="navbar-brand" href="#">
            {props.title}
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <a className="nav-link active" aria-current="page" href="/">
                  Home
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#">
                  {props.aboutText}
                </a>
              </li>
            </ul>

            <div
              style={{
                borderStyle: "solid",
                display: "flex",
                color: "white",
                borderRadius: 100,
                borderWidth: 14,
                justifyContent: "center",
                marginRight: 5,
                marginLeft: 910,
              }}
              onClick={props.toggleModeBlue}
            ></div>
            <div
              style={{
                borderStyle: "solid",
                display: "flex",
                color: "#198754",
                borderRadius: 100,
                borderWidth: 14,
                justifyContent: "center",
                marginRight: 5,
              }}
              onClick={props.toggleModeGreen}
            ></div>
            <div
              style={{
                borderStyle: "solid",
                display: "flex",
                color: "#6b055f",
                borderRadius: 100,
                borderWidth: 14,
                justifyContent: "center",
              }}
              onClick={props.toggleModePurple}
            ></div>
          </div>
        </div>
      </nav>
    </>
  );
};

Navbar.defaultProps = {
  title: "hello there",
  aboutText: "go away",
};
